import React from 'react';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { useUser } from 'shared/hooks/use-user';
import { PageEvents } from 'shared/services/tracking';
import { GoalGroupBy } from 'shared/types/sorting-mode';

import { LifeAreaGroupingGoalList } from '../life-area-grouping-goal-list';
import { NoGroupingGoalList } from '../no-grouping-goal-list';
import { TabPanel } from '../tab-panel';
import * as Styled from './group-by-list.style';

const groupByLists: Record<GoalGroupBy, React.FC> = {
  [GoalGroupBy.None]: NoGroupingGoalList,
  [GoalGroupBy.LifeArea]: LifeAreaGroupingGoalList,
};

export const GroupByList: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.GoalsList, undefined);
  const user = useUser();
  const GoalListComponent =
    groupByLists[user?.settings?.goalGroupBy ?? GoalGroupBy.None] ??
    groupByLists[GoalGroupBy.None];

  return (
    <TabPanel role="tab-panel">
      <Styled.GroupingContainer>
        <GoalListComponent />
      </Styled.GroupingContainer>
    </TabPanel>
  );
};
